import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { BoxMemberNextBooking } from "@modules/members/entities/memberEntity"
import { colors } from "@modules/ui/styles/colors"
import dayjs from "dayjs"
import { Text } from "@/components/ui/baseUi/text"

export type HuNextBookingCardProps = {
  nextBooking?: BoxMemberNextBooking
  className?: string
} & React.ComponentProps<"div">

export function HuNextBookingCard({ nextBooking, className, ...props }: HuNextBookingCardProps) {
  const nextB = nextBooking
    ? nextBooking
    : {
        slotId: "",
        name: word("huNextBookingCard.noBooking"),
        date: new Date(),
        color: colors.neutral300,
      }
  const formattedDate = dayjs(nextB.date).format("LLL")

  return (
    <div className={cn("relative flex w-max rounded-r-lg bg-neutral-200 py-3 pr-4", className)} {...props}>
      <div className="absolute top-0 left-0 h-full" style={{ width: "5px", backgroundColor: `${nextB.color}` }}></div>
      {nextBooking ? (
        <div className="ml-3 flex flex-col gap-1">
          <Text fontStyle="BM" className="text-textDefault-body">
            {nextB.name}
          </Text>
          <Text fontStyle="BS" className="text-textDefault-caption">
            {formattedDate}
          </Text>
        </div>
      ) : (
        <div className="ml-3">{nextB.name}</div>
      )}
    </div>
  )
}
